// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"acc1c62f","787":"a542a446","792":"4a62bd2d"}[chunkId] + ".chunk.js";
};